const dataTableData = {
  columns: [
    { Header: "#", accessor: "index", width: "5%" },
    { Header: "الاسم", accessor: "displayName", width: "15%" },
    { Header: "البريد الإلكتروني", accessor: "email", width: "15%" },
    // { Header: "اسم المستخدم", accessor: "userName", width: "15%" },
    { Header: "نوع المستخدم", accessor: "userTypeName", width: "10%" },
    { Header: "الشركة", accessor: "companyName", width: "15%" },
    { Header: "الحالة", accessor: "isEnabled", width: "10%" },
    { Header: "تاريخ الإنشاء", accessor: "createdAt", width: "10%" },
    { Header: "اجراء", accessor: "actions", width: "5%" },
  ],

  rows: [], // Will be populated with API data


};

export default dataTableData;
